import { NSARouterMakerResult } from "namirasoft-account-react";
import { NSBox, NSButtonBlue, NSColumn, NSCopy, NSLabel, NSLineText, NSTabPage, NSTitle } from "namirasoft-site-react";
import { Component } from "react";
import InfraNodeStatusLabel from "../components/InfraNodeStatusLabel";
import { InfraEntities } from "../InfraEntities";
import { InfraLayout } from '../InfraLayout';
import { InfraRouterProps } from "../InfraRouterProps";

interface ServerViewPageProps extends NSARouterMakerResult, InfraRouterProps { }

interface ServerViewPageState
{
    config_token?: string;
}

export default class ServerViewPage extends Component<ServerViewPageProps, ServerViewPageState>
{
    constructor(props: ServerViewPageProps)
    {
        super(props);
        this.state = {};
    }

    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={
                    {
                        entity: InfraEntities.server(this.props),
                        view: {
                            ui: {
                                getChildrenBefore: (_, row) => (
                                    <NSColumn classList={["mb-4 p-0 align-items-center"]}>
                                        <NSLabel
                                            title="Status" style={{ width: NSBox.width.one }}
                                        >
                                            <InfraNodeStatusLabel
                                                node={row}
                                                getOnlineList={this.props.servers.infra.server.ListOnline}
                                            />
                                        </NSLabel>
                                    </NSColumn >
                                ),
                                getChildrenAfter: (id, _) => (
                                    <NSColumn classList={["my-4"]}>
                                        <NSTitle title="Commands" />
                                        <NSTabPage
                                            tabs={[
                                                {
                                                    title: "Linux",
                                                    clicked: true,
                                                    getContent: () => (
                                                        <NSColumn>
                                                            <NSLineText title="Installation" />
                                                            <NSLabel
                                                                title="Install"
                                                                description="Use this command to install the Namirasoft Agent on your server."
                                                            >
                                                                <NSCopy classList={["text-dark"]}>
                                                                    <code style={{ lineBreak: "anywhere" }}>sudo curl -sSL https://static.namirasoft.com/script/namirasoft-infra-agent/linux/install.sh | bash</code>
                                                                </NSCopy>
                                                            </NSLabel>
                                                            <NSLabel
                                                                title="Config"
                                                                description="After the installation: \n > 1- Click the config below button to get a new credential\n > 2- Run the command to configure the agent.\n That is it!"
                                                            >
                                                                {
                                                                    this.state.config_token
                                                                        ?
                                                                        <NSCopy classList={["text-dark"]} value={`ns-infra-agent login --AgentID ${id} --Token ${this.state.config_token}`}>
                                                                            <code style={{ lineBreak: "anywhere", userSelect: "none" }}>{`ns-infra-agent login --AgentID ${id} --Token ****************`}</code>
                                                                        </NSCopy>
                                                                        :
                                                                        <NSButtonBlue
                                                                            title="Get command"
                                                                            classList={["mt-2"]}
                                                                            onClick={{
                                                                                showLoading: true,
                                                                                action: async (onFinished) =>
                                                                                {
                                                                                    try
                                                                                    {
                                                                                        let config_token = await this.props.servers.infra.server.GetToken(id);
                                                                                        this.setState(() => ({ config_token }), onFinished);
                                                                                    }
                                                                                    catch (error)
                                                                                    {
                                                                                        this.props.notifier.onError(error as Error);
                                                                                        onFinished();
                                                                                    }
                                                                                }
                                                                            }}
                                                                        />
                                                                }
                                                            </NSLabel>
                                                            <NSLineText title="Service Commands" />
                                                            <NSLabel
                                                                title="Status"
                                                                description="Shows the current systemd service state of the agent (active, inactive, failed) along with the most recent log lines.\nUse this to confirm the agent is running, check uptime, or diagnose issues after install or configuration."
                                                            >
                                                                <NSCopy classList={["text-dark"]}>
                                                                    <code style={{ lineBreak: "anywhere" }}>sudo systemctl status ns-infra-agent.service</code>
                                                                </NSCopy>
                                                            </NSLabel>
                                                            <NSLabel
                                                                title="Start"
                                                                description="Starts the Namirasoft Agent service.\nUse this when the agent has been stopped manually or failed to launch, and you want it to begin reporting to the console again."
                                                            >
                                                                <NSCopy classList={["text-dark"]}>
                                                                    <code style={{ lineBreak: "anywhere" }}>sudo systemctl start ns-infra-agent.service</code>
                                                                </NSCopy>
                                                            </NSLabel>
                                                            <NSLabel
                                                                title="Stop"
                                                                description="Stops the Namirasoft Agent service immediately.\nUse this when you need to take the server offline from the console temporarily â€” for maintenance, debugging, or before uninstalling â€” without removing the agent."
                                                            >
                                                                <NSCopy classList={["text-dark"]}>
                                                                    <code style={{ lineBreak: "anywhere" }}>sudo systemctl stop ns-infra-agent.service</code>
                                                                </NSCopy>
                                                            </NSLabel>
                                                            <NSLabel
                                                                title="Restart"
                                                                description="Stops and then starts the agent service in a single step.\nUse this after changing the agent configuration or upgrading it, to make the new settings take effect."
                                                            >
                                                                <NSCopy classList={["text-dark"]}>
                                                                    <code style={{ lineBreak: "anywhere" }}>sudo systemctl restart ns-infra-agent.service</code>
                                                                </NSCopy>
                                                            </NSLabel>
                                                            <NSLineText title="Uninstall Commands" />
                                                            <NSLabel
                                                                title="Uninstall"
                                                                description="Completely removes the Namirasoft Agent from the server, including its service, binaries, and configuration.\nUse this when retiring the server from the console or before performing a clean reinstall."
                                                            >
                                                                <NSCopy classList={["text-dark"]}>
                                                                    <code style={{ lineBreak: "anywhere" }}>sudo curl -sSL https://static.namirasoft.com/script/namirasoft-infra-agent/linux/uninstall.sh | bash</code>
                                                                </NSCopy>
                                                            </NSLabel>
                                                        </NSColumn>
                                                    )
                                                }
                                            ]}
                                        />
                                    </NSColumn>
                                )
                            }
                        }
                    }
                }
            >
                <></>
            </InfraLayout>
        );
    }
}